import { MapToContext } from '@utils/objectWithDefault'

export default class QuickSetupStep {
  constructor (quickSetupStep) {
    const defaultQuickSetupStep = {
      stp: {val: '', type: String},
      cmp: {val: false, type: Boolean},
      skp: {val: false, type: Boolean}
    }
    MapToContext(this, defaultQuickSetupStep, quickSetupStep)
  }
}
